import {
  FETCH_PROJECT_ROUTES,
  FETCH_PROJECT_ROUTES_FAILURE,
  FETCH_PROJECT_ROUTES_SUCCESS,
  FETCH_PROJECT_STRUCTURE,
  FETCH_PROJECT_STRUCTURE_FAILURE,
  FETCH_PROJECT_STRUCTURE_SUCCESS,
  PROJECT_ROUTES_BULK_DELETE,
  PROJECT_ROUTES_BULK_DELETE_FAILURE,
  PROJECT_ROUTES_BULK_DELETE_SUCCESS,
  PROJECT_ROUTES_CLEAR_STATE,
  PROJECT_ROUTES_SELECTION_CHANGED,
  ROUTE_TREE_THUMBNAIL_DETAILS_CHANGED,
  SET_VIEW_ROUTES_POSITION,
} from '@Pages/RetroSynthesis/ProjectRoutes/constants';

export const initialState = {
  isLoading: false,
  response: undefined,
  selectedIds: [],
  targetResponse: undefined,
  error: undefined,
  treeTooltip: {
    data: undefined,
    target: undefined,
  },
  remainingRoutesCount: null,
  lastViewedRoutesPosition: null, // { scrollTop: last table scroll position, id: last route id }
};

// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_PROJECT_ROUTES:
      return { ...state, isLoading: true, error: undefined };
    case FETCH_PROJECT_ROUTES_SUCCESS:
      return { ...state, isLoading: false, error: undefined, response: action.payload };
    case FETCH_PROJECT_ROUTES_FAILURE:
      return { ...state, isLoading: false, error: action.payload, response: undefined };
    case PROJECT_ROUTES_SELECTION_CHANGED:
      return { ...state, selectedIds: action.payload };
    case FETCH_PROJECT_STRUCTURE:
    case FETCH_PROJECT_STRUCTURE_FAILURE:
      return { ...state, targetResponse: undefined, selectedIds: [] };
    case FETCH_PROJECT_STRUCTURE_SUCCESS:
      return { ...state, targetResponse: action.payload };
    case SET_VIEW_ROUTES_POSITION:
      return { ...state, lastViewedRoutesPosition: action.payload };
    case ROUTE_TREE_THUMBNAIL_DETAILS_CHANGED:
      return { ...state, treeTooltip: { ...action.payload } };
    case PROJECT_ROUTES_CLEAR_STATE:
      return { ...initialState, lastViewedRoutesPosition: state.lastViewedRoutesPosition };
    case PROJECT_ROUTES_BULK_DELETE:
      return { ...state, remainingRoutesCount: null };
    case PROJECT_ROUTES_BULK_DELETE_SUCCESS:
      return { ...state, remainingRoutesCount: action.payload };
    case PROJECT_ROUTES_BULK_DELETE_FAILURE:
      return { ...state, error: action.payload };
    default: {
      return state;
    }
  }
}
